export type PointDrawMode = 'node' | 'grouped'

export const DEFAULT_POINT_DRAW_MODE: PointDrawMode = 'grouped'
export const DEFAULT_POINT_BUDGET = 20_000_000
export const DEFAULT_GROUPED_DRAW_POINT_LIMIT = 10_000_000

export interface PointCloudDemoUrlConfig {
  readonly pointDrawMode: PointDrawMode
  readonly pointBudget: number
  readonly groupedDrawPointLimit: number
}

export interface PointCloudDemoUrlPatch {
  readonly pointDrawMode?: PointDrawMode
  readonly pointBudget?: number
  readonly groupedDrawPointLimit?: number
}

function parseHash(hash: string): URLSearchParams {
  return new URLSearchParams(hash.split('?')[1] ?? '')
}

function readPositiveInteger(value: number, fallback: number): number {
  return Number.isFinite(value) && value > 0 ? Math.max(1, Math.round(value)) : fallback
}

function readInteger(query: URLSearchParams, key: string, fallback: number): number {
  const raw = query.get(key)
  if (raw === null) return fallback
  return readPositiveInteger(Number(raw), fallback)
}

export function readPointCloudDemoUrlConfig(
  hash = window.location.hash
): PointCloudDemoUrlConfig {
  const query = parseHash(hash)
  const rawDrawMode = query.get('pointDraw')
  return {
    pointDrawMode: rawDrawMode === 'nodes' ? 'node' : DEFAULT_POINT_DRAW_MODE,
    pointBudget: readInteger(query, 'budget', DEFAULT_POINT_BUDGET),
    groupedDrawPointLimit: readInteger(
      query,
      'groupedPoints',
      DEFAULT_GROUPED_DRAW_POINT_LIMIT
    ),
  }
}

export function writePointCloudDemoUrlConfig(
  patch: PointCloudDemoUrlPatch,
  hash = window.location.hash
): string {
  const [pathPart, queryPart = ''] = hash.split('?')
  const query = new URLSearchParams(queryPart)
  if (patch.pointDrawMode !== undefined) {
    query.set('pointDraw', patch.pointDrawMode === 'grouped' ? 'batched' : 'nodes')
  }
  if (patch.pointBudget !== undefined) {
    query.set('budget', String(readPositiveInteger(patch.pointBudget, DEFAULT_POINT_BUDGET)))
  }
  if (patch.groupedDrawPointLimit !== undefined) {
    query.set(
      'groupedPoints',
      String(readPositiveInteger(patch.groupedDrawPointLimit, DEFAULT_GROUPED_DRAW_POINT_LIMIT))
    )
  }
  return `${pathPart}?${query.toString()}`
}

/** 修改 grouped/demo 配置后强制整页刷新，确保渲染资源按新参数重新创建。 */
export function reloadPointCloudDemoConfig(patch: PointCloudDemoUrlPatch): void {
  window.location.hash = writePointCloudDemoUrlConfig(patch)
  window.location.reload()
}
